import React from 'react';
import { motion } from 'framer-motion';
import { Watermark } from './Watermark';
export function Description() {
  return <section className="relative overflow-hidden py-14 sm:py-20 lg:py-24 px-5 sm:px-6 bg-nude-light" data-id="element-123" data-mp="1heys3q96qlob">
      <Watermark position="right" size={750} opacity={0.05} data-id="element-124" data-mp="1v5v9ekxnvgg2" />
      <div className="relative z-10 max-w-4xl mx-auto text-center" data-id="element-125" data-mp="1r5tcep2vfb74">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} data-id="element-126" data-mp="1r7nzoa1m7fed">
          <span className="text-gold uppercase tracking-[0.2em] text-sm font-medium mb-4 block" data-id="element-127" data-mp="17hkcttz002xl">
            La Experiencia Alexa Beauty
          </span>
          <h2 className="text-3xl md:text-5xl font-serif text-luxury-black mb-6 sm:mb-8 leading-tight" data-id="element-128" data-mp="2nuivgiq8i9uo">
            MÁS QUE UN KIT… <br className="hidden md:block" data-id="element-129" data-mp="2iwhcdxst6aj7" />
            <span className="italic text-gray-500" data-id="element-130" data-mp="4sfc0f55v779">UNA IMAGEN PROFESIONAL</span>
          </h2>

          <div className="space-y-6 text-lg md:text-xl text-gray-600 font-sans font-light leading-relaxed" data-id="element-131" data-mp="8sy4mbevohai">
            <p data-id="element-132" data-mp="dsaqasu0jibi">
              Nuestros kits Alexa Beauty fueron creados para mujeres
              profesionales que desean trabajar organizadas, verse elegantes y
              ofrecer una mejor experiencia a sus clientas.
            </p>
            <p data-id="element-133" data-mp="3hb41x038dx31">
              Cada detalle fue pensado para combinar funcionalidad, belleza y
              presencia profesional.
            </p>
            <p className="font-medium text-luxury-black" data-id="element-134" data-mp="3r6yo256nyaak">
              No solo compras accesorios… compras presentación, comodidad y
              estilo.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}